import {AdminTabs} from "../components/AdminTabs";
import {appAccessCardClass} from "./app-access-ui";

export type AppAccessWorkflow = "ONE_PERSON" | "REUSABLE";

export type AppAccessWorkflowTabsProps = {
  activeWorkflow: AppAccessWorkflow;
  onePersonCount: number;
  reusableCount: number;
  onChange: (workflow: AppAccessWorkflow) => void;
};

/** Keeps short-lived individual setup links separate from standing onboarding kits. */
export const AppAccessWorkflowTabs = ({
  activeWorkflow,
  onePersonCount,
  reusableCount,
  onChange,
}: AppAccessWorkflowTabsProps) => (
  <section className={`${appAccessCardClass} overflow-hidden !p-0`} aria-label="App Access workflow">
    <div className="px-4 pt-4 sm:px-6">
      <h2 className="font-semibold text-[var(--ots-secondary)]">What do you need to send?</h2>
      <p className="mt-1 text-sm text-[var(--ots-text-muted)]">
        Keep single-person setup links separate from reusable implementation and onboarding materials.
      </p>
    </div>
    <AdminTabs
      tabs={[
        {id: "REUSABLE", label: "Reusable onboarding", count: reusableCount},
        {id: "ONE_PERSON", label: "Individual setups", count: onePersonCount},
      ]}
      activeTab={activeWorkflow}
      onChange={onChange}
      ariaLabel="App Access workflow"
      idPrefix="app-access-workflow"/>
  </section>
);
